import ApiService from "@/core/services/api.service";

const state = {
  errors: null,
  collection: [],
};

const getters = {
  transferCollection(state) {
    return state.collection;
  },

  getTransferByID: (state) => (id) => {
    return state.collection.find((item) => item.id == id);
  },
};

const actions = {
  fetchTransfer(context) {
    ApiService.get("stock/transfer")
      .then(({ data }) => {
        context.commit("fetchTransfer", data);
      })
      .catch((error) => {
        console.log("Error!: ", error);
      });
  },
};

const mutations = {
  fetchTransfer(state, data) {
    state.collection = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
